import { Button, ButtonProps, chakra } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { useRouteMatch } from '@/hooks/useRouteMatch';

export type NavigationButtonProps = {
  href: string;
  matchHref?: string;
  isExact?: boolean;
  isActive?: boolean;
} & ButtonProps;

export const NavigationButton: React.FC<NavigationButtonProps> = ({
  href,
  matchHref,
  children,
  isExact,
  isActive,
  ...buttonProps
}) => {
  const isRouteMatch = useRouteMatch(matchHref ?? href, { isExact });

  const isConsideredActive = isActive !== undefined ? isActive : isRouteMatch;

  return (
    <Button
      as={NextLink}
      href={href}
      whiteSpace="normal"
      variant="ghost"
      justifyContent="left"
      colorScheme="gray"
      isActive={isConsideredActive}
      borderRadius="xl"
      size="lg"
      color={isConsideredActive ? 'gray.800' : 'gray.600'}
      {...buttonProps}
    >
      <chakra.span noOfLines={1} wordBreak="break-all">
        {children}
      </chakra.span>
    </Button>
  );
};
